import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "page-builder-components"
    }}>{`Page Builder components`}</h1>
    <p>{`The Page Builder integration for PWA Studio provides React components that render the default Page Builder content types.`}</p>
    <h2 {...{
      "id": "list-of-components"
    }}>{`List of components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Banner/"
        }}>{`Banner`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Block/"
        }}>{`Block`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Buttons/"
        }}>{`Buttons and ButtonItem`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Column/"
        }}>{`Column and ColumnGroup`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Divider/"
        }}>{`Divider`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "DynamicBlock/"
        }}>{`Dynamic Block`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Heading/"
        }}>{`Heading`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "HTML-Code/"
        }}>{`HTML Code`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Image/"
        }}>{`Image`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Map/"
        }}>{`Map`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Products/"
        }}>{`Products`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Row/"
        }}>{`Row`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Slider/"
        }}>{`Slider`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Tabs/"
        }}>{`Tabs and TabItem`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Text/"
        }}>{`Text`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Video/"
        }}>{`Video`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      